import store from 'store'

const el = '[data-content=ProductAddedOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProductAddedOverlayDOM)=>{
            const maxRecommendations = ProductAddedOverlayDOM.dataset.maxRecommendations
            const footerRightCtaUrl = ProductAddedOverlayDOM.dataset.footerRightCtaUrl
            store.commit('main/set_page_overlay_content_data', { footerRightCtaUrl, maxRecommendations })
        })
    }
}